import { $generateNodesFromDOM } from "@lexical/html";
import {
  $insertNodes,
  DOMConversionMap,
  LexicalEditor,
  LexicalNode,
} from "lexical";
import {
  $createBeautifulMentionNode,
  BeautifulMentionNode,
} from "lexical-beautiful-mentions";
import { ArticleProps } from "../../../../../../redux/slices/article/Article";
import { plugins } from "@thisgorilla/primate-ds";

const { $createCustomUrlNode } = plugins.UrlMetadataPlugin;

export const editorTheme = {
  indent: "indent",
  list: {
    listitem: "listItem",

    nested: {
      listitem: "nestedListItem",
    },
    olDepth: ["ol1", "ol2", "ol3", "ol4", "ol5"],
    ul: "ul",
  },
  paragraph: "paragraph",
  text: {
    bold: "textBold",
    italic: "textItalic",
    underline: "textUnderline",
  },
  beautifulMentions: { "@": "selected-mention" },
};

export const convertHtmlToNode = (editor: LexicalEditor, html: string) => {
  editor.update(() => {
    editor.update(() => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(html, "text/html");
      const nodes = $generateNodesFromDOM(editor, dom);
      $insertNodes(nodes);
      setTimeout(() => {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      }, 0);
    });
  });
};

export const exportMentionAsTemplate = (
  editor: LexicalEditor,
  target: LexicalNode
): { element: HTMLElement } => {
  if (target instanceof BeautifulMentionNode) {
    const data: any = target.getData();
    const element = document.createElement("span");
    element.innerHTML = `{{ @user:${data.id} }}`;
    return {
      element,
    };
  }
  return { element: document.createElement("span") };
};

export const constructImportMap = (
  mentionList: ArticleProps.User[],
  urls: ArticleProps.Url[]
): DOMConversionMap => {
  return {
    span: (node: HTMLElement) => {
      if (node.textContent?.includes("{{ @url:")) {
        const match = node.textContent.match(/{{ @url:(.*?) }}/);
        if (match) {
          const id = match[1];
          const urlData = urls.find((url) => url.id === id) as ArticleProps.Url;
          return {
            conversion: () => {
              const node = $createCustomUrlNode(
                id,
                urlData.url,
                urlData.title,
                urlData.og_image,
                urlData.description
              );
              return { node };
            },
            priority: 1,
          };
        }
      }

      if (node.textContent?.includes("{{ @user:")) {
        const match = node.textContent.match(/{{ @user:(.*?) }}/);
        if (match) {
          const id = match[1];
          return {
            conversion: () => {
              const mentionUserData = mentionList.find(
                (mention) => mention.id === id
              ) as ArticleProps.User;

              const node = $createBeautifulMentionNode(
                "@",
                mentionUserData.first_name + " " + mentionUserData.last_name,
                {
                  id: mentionUserData.id,
                  profile_picture: mentionUserData.profile_picture,
                  value:
                    mentionUserData.first_name +
                    " " +
                    mentionUserData.last_name,
                }
              );
              return { node };
            },
            priority: 1,
          };
        }
      }

      return null;
    },
  };
};
